import { GetAccountCallsPerWorkspaceSummaryResponseDto } from '../../../../../src/interface/dtos/org-metrics/calls/get-account-calls-per-workspace-summary-response.dto';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { GetAccountCallsPerWorkspaceSummaryRequestDto } from '../../../../../src/interface/dtos/org-metrics/calls/get-account-calls-per-workspace-summary-request.dto';
import { AccountCallsPerWorkspaceSummaryAggregateRootMapper } from '../../../../../src/infrastructure/mappers/org-metrics/calls/account-calls-per-workspace-summary.aggregate-root.mapper';
import { GetAccountCallsPerWorkspaceSummaryQuery } from '../../../../../src/interface/queries/org-metrics/calls/get-account-calls-per-workspace-summary.query';


export class GetAccountCallsPerWorkspaceSummaryController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountCallsPerWorkspaceSummaryQuery,
    protected readonly mapper: AccountCallsPerWorkspaceSummaryAggregateRootMapper
  ) {}

  async get(
    props: GetAccountCallsPerWorkspaceSummaryRequestDto
  ): Promise<GetAccountCallsPerWorkspaceSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetAccountCallsPerWorkspaceSummaryController.get encountered an error ${error}`
      );
    }
  }
}
